import { _ as _define_property } from "@swc/helpers/_/_define_property";
export const EXEMPTION_REASONS = [
    'nonprofit501c3',
    'governmentEntity',
    'tribalGovernment',
    'religiousOrganization',
    'educationalInstitution',
    'resaleCertificate',
    'directPayPermit',
    'outOfStatePurchaser',
    'other'
];
export const DEFAULT_CLIENT_TAX_SETTINGS = {
    type: 'taxable',
    taxable: {
        ratePresetId: null
    }
};
export const isClientTaxExempt = (settings)=>settings.type === 'exempt';
export const clientTaxRatePresetId = (settings)=>settings.type === 'taxable' ? settings.taxable.ratePresetId : null;
export class ClientModel {
    clientId() {
        return this.dto.clientId;
    }
    name() {
        return this.dto.name;
    }
    clientType() {
        return this.dto.clientType;
    }
    isSample() {
        return this.dto.isSample;
    }
    status() {
        return this.dto.status;
    }
    owner() {
        return this.dto.owner;
    }
    contactsCount() {
        return this.dto.contactsCount;
    }
    archiveEligibility() {
        var _this_dto_archiveEligibility;
        return (_this_dto_archiveEligibility = this.dto.archiveEligibility) !== null && _this_dto_archiveEligibility !== void 0 ? _this_dto_archiveEligibility : {
            type: 'eligible'
        };
    }
    deleteEligibility() {
        var _this_dto_deleteEligibility;
        return (_this_dto_deleteEligibility = this.dto.deleteEligibility) !== null && _this_dto_deleteEligibility !== void 0 ? _this_dto_deleteEligibility : {
            type: 'eligible'
        };
    }
    isMultiVendorCustomer() {
        return this.dto.isMultiVendorCustomer;
    }
    taxSettings() {
        var _this_dto_taxSettings;
        return (_this_dto_taxSettings = this.dto.taxSettings) !== null && _this_dto_taxSettings !== void 0 ? _this_dto_taxSettings : DEFAULT_CLIENT_TAX_SETTINGS;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
